export function formatCount(value: number): string {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(1)} 亿`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return value.toLocaleString("zh-CN");
}

export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return String(value);
}

export function heatToPercent(value: number, max: number): number {
  if (max <= 0) return 0;
  const percent = Math.round((value / max) * 100);
  return Math.min(100, Math.max(12, percent));
}